import React, { PropTypes } from 'react';
import $ from 'jquery';
import { compose, pure } from 'recompose';
import cx from 'classnames';
import { reduxForm } from 'redux-form';
import { fieldClass } from 'common/semantic/utils';
import { colorpicker } from 'plugins/color';
import { DEFAULT_COLOR } from 'constants/product';
import NodeGravity from './NodeGravity';
import NodeScaleType from './NodeScaleType';

const validate = values => {
  const errors = {};
  if (!values.title) {
    errors.title = true;
  }

  return errors;
};

class NodeForm extends React.Component {
  static propTypes = {
    node: PropTypes.object,
    fields: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    renderImage: PropTypes.func.isRequired,
    renderTabletImage: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    colorDisabled: PropTypes.bool.isRequired,
    tabletFieldsDisabled: PropTypes.bool.isRequired,
  };

  constructor(props, context) {
    super(props, context);

    this.goBack = this.goBack.bind(this);
    this.onGravityChange = this.onGravityChange.bind(this);
    this.onScaleTypeChange = this.onScaleTypeChange.bind(this);
  }

  goBack(evt) {
    evt.preventDefault();
    this.context.router.goBack();
  }

  componentDidMount() {
    const { fields } = this.props;

    const cp = field => {
      colorpicker($(this.refs[field])).on('change', evt => {
        const color = evt.target.value;
        fields[field].onChange(color);
      });
    };

    cp('color');
    cp('tabletColor');
  }

  onGravityChange(value) {
    const { fields } = this.props;

    fields['gravity'].onChange(value);
  }

  onScaleTypeChange(value) {
    const { fields } = this.props;

    fields['scaleType'].onChange(value);
  }

  render() {
    const {
      fields: { title, description, color, template, tabletColor },
      handleSubmit,
      submitting,
      label,
      colorDisabled,
      tabletFieldsDisabled,
      renderImage,
      renderTabletImage,
      values: { gravity, scaleType },
      node,
    } = this.props;

    const isRoot = node && node.parent === null;

    const isGravityDisabled =
      tabletFieldsDisabled || (scaleType && scaleType === 'crop');
    const tabletColorClass = cx('field', {
      disabled: tabletFieldsDisabled,
    });

    const nameFieldClass = fieldClass(name, {
      disabled: isRoot,
    });

    return (
      <form className="ui form" onSubmit={handleSubmit}>
        <h4 className="ui dividing header">Noeud</h4>
        <div className="ui grid">
          <div className="three wide column">{renderImage()}</div>
          <div className="thirteen wide column">
            <div className={nameFieldClass}>
              <label>Nom</label>
              <input type="text" name="title" placeholder="Nom" {...title} />
            </div>
            {!isRoot && (
              <div className="field">
                <label>Description</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Description"
                  {...description}
                />
              </div>
            )}
            {!colorDisabled && (
              <div className="field">
                <label>Couleur</label>
                <input type="text" name="color" ref="color" {...color} />
              </div>
            )}
            {!isRoot && (
              <div className="field">
                <label>Template</label>
                <select
                  className="ui dropdown"
                  {...template}
                  value={template.value || 'simple'}
                >
                  <option value="simple">Simple</option>
                  <option value="contextual">Contextuel</option>
                </select>
              </div>
            )}
          </div>
        </div>
        {!isRoot && (
          <div>
            <div className="ui hidden divider" />
            <h4 className="ui dividing header">Visuel tablette</h4>
            <div className="ui grid">
              <div className="three wide column">{renderTabletImage()}</div>
              <div className="thirteen wide column">
                <NodeScaleType
                  value={scaleType}
                  disabled={tabletFieldsDisabled}
                  onChange={this.onScaleTypeChange}
                />
                <NodeGravity
                  value={gravity}
                  disabled={isGravityDisabled}
                  onChange={this.onGravityChange}
                />
                <div className={tabletColorClass}>
                  <label>Couleur</label>
                  <input
                    type="text"
                    name="tabletColor"
                    ref="tabletColor"
                    {...tabletColor}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="ui hidden divider" />
        <button
          className="ui right floated primary button"
          type="submit"
          disabled={submitting}
        >
          {label}
        </button>
        <button className="ui right floated button" onClick={this.goBack}>
          Annuler
        </button>
      </form>
    );
  }
}

NodeForm.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default compose(
  reduxForm(
    {
      form: 'node',
      fields: [
        'title',
        'description',
        'color',
        'template',
        'gravity',
        'scaleType',
        'tabletColor',
      ],
      validate,
    },
    (state, ownProps) => {
      const { node } = ownProps;

      const nodeFieldOrDefault = (field, defaultVal = '') => {
        const value = node ? node[field] : '';
        return value || defaultVal;
      };

      const tabletFieldOrDefault = (field, defaultVal = '') => {
        const value = node && node.tablet_image ? node.tablet_image[field] : '';
        return value || defaultVal;
      };

      const template = nodeFieldOrDefault('template');
      const color = nodeFieldOrDefault('color', DEFAULT_COLOR);
      const description = nodeFieldOrDefault('description');
      const scaleType = tabletFieldOrDefault('scale_type');
      const gravity = tabletFieldOrDefault('gravity');
      const tabletColor = tabletFieldOrDefault('color');

      return {
        initialValues: {
          ...node,
          color,
          template,
          description,
          scaleType,
          gravity,
          tabletColor,
        },
      };
    }
  ),
  pure
)(NodeForm);



// WEBPACK FOOTER //
// ./src/modules/catalog/components/NodeForm.js